export default __webpack_public_path__ + "static/media/carbon_query.0e86623f.svg";